var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import '@src/app/styles/datatable.css';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FormatDate, FormatDateEpoch, FormatYearMonthDate } from '@src/app/helper';
import Date from '../../Date/Date';
import { upSchedule } from '@src/components/molecules/Schedule/NoSchedule/NoSchedule.request';
import TextAreaFormik from '../../Formik/TextArea/TextAreaFormik';
import InputFormik from '../../Formik/Input/InputFormik';
import FileFormik from '../../Formik/Input/FileFormik';
import { uploadFile } from '@src/app/pages/JobPage/Job/Job.requests';
import dayjs from 'dayjs';
import { handleFocus } from '@src/app/helper/NumberHelpers';
var UpScheduleForm = function (_a) {
    var record = _a.record, refetch = _a.refetch, handleClose = _a.handleClose;
    var _b = useState(false), isOpenUp = _b[0], setIsOpenUp = _b[1];
    var _c = useState(), upId = _c[0], setUpId = _c[1];
    var _d = useState(''), scheduleId = _d[0], setScheduleId = _d[1];
    var _e = useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var _f = useState(), upDate = _f[0], setUpDate = _f[1];
    var _g = useState({
        proofUploadFilePubId: '',
    }), files = _g[0], setFiles = _g[1];
    var onChangeUpDate = function (e, name) {
        var value = FormatDate(e).split('/').reverse().join('-');
        UpFormik.setFieldValue(name, value);
        setUpDate(e);
    };
    var onChangeFiles = function (e) {
        var _a;
        setFiles(__assign(__assign({}, files), (_a = {}, _a[e.target.name] = e.target.files, _a)));
        UpFormik.setFieldValue(e.target.name, e.target.files);
    };
    //up
    var upItem = function (record, index) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setScheduleId(record);
            setUpId(index);
            setIsOpenUp(!isOpenUp);
            return [2 /*return*/];
        });
    }); };
    var UpFormSchema = Yup.object().shape({
    // isBriefOk: Yup.string(),
    // briefNote: Yup.string(),
    });
    var insight = record === null || record === void 0 ? void 0 : record.schedules[0].schedule;
    var UpFormik = useFormik({
        initialValues: {
            upDate: '',
            upLink: '',
            isBriefOk: true,
            briefNote: '',
            proofUploadFilePubId: '',
            views: insight.views || '',
            likes: insight.likes || '',
            share: insight.share || '',
            comment: insight.comment || '',
            impression: insight.impression || '',
            reach: insight.reach || '',
        },
        enableReinitialize: true,
        validationSchema: UpFormSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var proof, _a, formValues, views, likes, share, comment, impression, reach, finalViews, finalLikes, finalShare, finalComment, finalImpression, finalReach, formData, _b, apiData, status_1, e_1, error;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, 5, 6]);
                        setIsSubmitting(true);
                        values.upDate = values.upDate !== '' ? values.upDate : FormatYearMonthDate(Number(dayjs()));
                        _a = values.proofUploadFilePubId;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadFile({
                                File: files.proofUploadFilePubId[0],
                                TenantPubId: record.talent.tenant.pubId,
                                TalentPubId: record.talent.pubId,
                                Type: 'ProofOfUploads',
                            })];
                    case 1:
                        _a = (_c.sent());
                        _c.label = 2;
                    case 2:
                        proof = _a;
                        formValues = __assign({}, values);
                        views = formValues.views, likes = formValues.likes, share = formValues.share, comment = formValues.comment, impression = formValues.impression, reach = formValues.reach;
                        finalViews = typeof views == 'string' ? views.replace(/\./g, '') : parseInt(views).toString();
                        finalLikes = typeof likes == 'string' ? likes.replace(/\./g, '') : parseInt(likes).toString();
                        finalShare = typeof share == 'string' ? share.replace(/\./g, '') : parseInt(share).toString();
                        finalComment = typeof comment == 'string' ? comment.replace(/\./g, '') : parseInt(comment).toString();
                        finalImpression = typeof impression == 'string'
                            ? impression.replace(/\./g, '')
                            : parseInt(impression).toString();
                        finalReach = typeof reach == 'string' ? reach.replace(/\./g, '') : parseInt(reach).toString();
                        formData = {
                            upDate: values.upDate,
                            upLink: values.upLink,
                            isBriefOk: values.isBriefOk,
                            briefNote: values.briefNote,
                            proofUploadFilePubId: proof && proof.data.data.pubId,
                            views: finalViews,
                            likes: finalLikes,
                            share: finalShare,
                            comment: finalComment,
                            impression: finalImpression,
                            reach: finalReach,
                        };
                        return [4 /*yield*/, upSchedule(scheduleId, formData)];
                    case 3:
                        _b = _c.sent(), apiData = _b.data, status_1 = _b.status;
                        if (status_1 === 200) {
                            toast.success(apiData.message);
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        e_1 = _c.sent();
                        error = e_1.response.data;
                        // setStatus(error.message)
                        toast.error(error.message);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsSubmitting(false);
                        handleClose(false);
                        refetch();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); },
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: 'd-flex flex-row border border-dashed border-gray-200 px-2 py-2' }, { children: [_jsx("div", __assign({ className: 'd-flex flex-column w-250px fw-bold' }, { children: "Sosial Media" })), _jsx("div", __assign({ className: 'd-flex flex-column w-250px fw-bold' }, { children: "Kerja Sama" })), _jsx("div", __assign({ className: 'd-flex flex-column w-300px fw-bold' }, { children: "Action" }))] })), record &&
                record.schedules &&
                record.schedules.length > 0 &&
                record.schedules.map(function (data, key) {
                    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: 'd-flex flex-row border border-dashed border-gray-200 px-2 py-2' }, { children: [_jsxs("div", __assign({ className: 'd-flex flex-column w-250px' }, { children: [_jsx("p", { children: data.jobDetail.profile.socialMedia.name }), _jsx("a", __assign({ href: data.jobDetail.profile.profileLink }, { children: data.jobDetail.profile.profileName }))] })), _jsxs("div", __assign({ className: 'd-flex flex-column w-250px' }, { children: [_jsxs("p", { children: [data.jobDetail.jobType.name, " - ", data.jobDetail.totalPosts, "x (", data.schedule.sequence, "/", data.jobDetail.totalPosts, ")"] }), _jsxs("p", { children: ["Note: ", data.schedule.note || '-'] }), _jsxs("p", { children: ["Jadwal: ", FormatDateEpoch(data.schedule.scheduleDate) || '-'] })] })), _jsx("div", __assign({ className: 'd-flex flex-column w-300px' }, { children: _jsx("div", { children: _jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-primary', onClick: function () { return upItem(data.schedule.pubId, key); } }, { children: "Up Schedule Ini" })) }) }))] })), isOpenUp && upId === key && (_jsx("div", __assign({ className: 'mb-5 bg-light' }, { children: _jsx("div", __assign({ className: 'px-5 py-5' }, { children: _jsxs("form", __assign({ id: 'up_form', className: 'form', noValidate: true, onSubmit: UpFormik.handleSubmit }, { children: [_jsx("div", __assign({ className: 'mb-5' }, { children: _jsxs("div", { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "Tanggal Up" })), _jsx(Date, { date: upDate, handleonchange: function (e) {
                                                                onChangeUpDate(e, 'upDate');
                                                            }, name: 'upDate' })] }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx("div", { children: _jsx(InputFormik, { label: 'Up Link', formik: UpFormik, name: 'upLink', placeholder: 'Up Link', type: 'text' }) }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx("div", { children: _jsx(TextAreaFormik, { label: 'Note', placeholder: 'Note', name: 'briefNote', formik: UpFormik }) }) })), _jsx("p", __assign({ className: 'text-sm mb-5 text-italic', style: { marginTop: '-1rem', fontStyle: 'italic' } }, { children: "*editing this will replace the current data" })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx("div", { children: _jsx(FileFormik, { label: 'Bukti Upload', placeholder: 'Bukti Upload', name: 'proofUploadFilePubId', formik: UpFormik, onChange: onChangeFiles }) }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx(InputFormik, { label: 'Views', type: 'text', placeholder: 'Views', name: 'views', formik: UpFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx(InputFormik, { label: 'Likes', type: 'text', placeholder: 'Likes', name: 'likes', formik: UpFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx(InputFormik, { label: 'Share', type: 'text', placeholder: 'Share', name: 'share', formik: UpFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx(InputFormik, { label: 'Comments', type: 'text', placeholder: 'Comments', name: 'comment', formik: UpFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx(InputFormik, { label: 'Impression', type: 'text', placeholder: 'Impression', name: 'impression', formik: UpFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'mb-5' }, { children: _jsx(InputFormik, { label: 'Reach', type: 'text', placeholder: 'Reach', name: 'reach', formik: UpFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", { children: _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-active-light-primary btn-sm mr-2', disabled: isSubmitting }, { children: [!isSubmitting && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), isSubmitting && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] })) })] })) })) })))] }, key));
                })] }));
};
export default UpScheduleForm;
